import { useGetIsUngated } from '../../hooks/useGetIsUngated';
import { useGetHasScope } from '../../hooks/useGetHasScope';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
//@ts-expect-error JS File
import { useIsEmbeddedContext } from 'customer-data-sidebar/universal/context/IsEmbeddedContext';
import AssociatedObjectsCardTitleDataProvider from './AssociatedObjectsCardTitleDataProvider';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { usePermissionsContext } from 'customer-data-sidebar/universal/context/PermissionsContext';
import { useContext } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { SourceAppContext } from 'customer-data-sidebar/universal/context/SourceAppContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { HostAppCallbacksContext } from 'customer-data-sidebar/universal/context/HostAppCallbacksContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { SidebarPropertySourceContext } from 'customer-data-sidebar/universal/context/SidebarPropertySourceContext';
import { jsx as _jsx } from "react/jsx-runtime";
function AssociatedObjectsCardTitleUniversalSidebarDataProvider({
  objectId,
  objectType,
  data
}) {
  const isUngated = useGetIsUngated();
  const hasScope = useGetHasScope();
  const isEmbedded = useIsEmbeddedContext();
  const toObjectTypeId = data.configuration.toObjectTypeId;
  const objectTypeId = normalizeTypeId(objectType);
  const {
    readOnly
  } = usePermissionsContext();
  //@ts-expect-error JS File
  const {
    sourceApp
  } = useContext(SourceAppContext);
  const propertyNames = data.configuration.properties.map(property => property.name);
  // @ts-expect-error JS File
  const {
    onAssociationUpdate,
    onObjectCreate,
    onObjectUpdate
  } = useContext(HostAppCallbacksContext);
  const propertySourceInfo = useContext(SidebarPropertySourceContext);
  return /*#__PURE__*/_jsx(AssociatedObjectsCardTitleDataProvider, {
    cardId: data.cardId,
    hasScope: hasScope,
    isEmbedded: isEmbedded,
    isUngated: isUngated,
    objectId: Number(objectId),
    objectTypeId: objectTypeId,
    onAssociationUpdate: onAssociationUpdate,
    onObjectCreate: onObjectCreate,
    onObjectUpdate: onObjectUpdate,
    propertyNames: propertyNames,
    propertySource: propertySourceInfo,
    readOnly: readOnly,
    sourceApp: sourceApp,
    toObjectTypeId: toObjectTypeId
  });
}
export default AssociatedObjectsCardTitleUniversalSidebarDataProvider;